import { withInstall } from '../utils/index';
import SubmapContainer from './index.vue';
import './index.less';

export const TlbsSubmapContainer = withInstall(SubmapContainer);
export default TlbsSubmapContainer;
